import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertService} from '../services/alert.service';
import {EnvService} from '../services/env.service';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'micro-cmdb-subnet-detail',
  templateUrl: './cmdb-subnet-detail.component.html'
})
export class CmdbSubnetDetailComponent implements OnInit {
  dataSource = new MatTableDataSource<any>();
  @Input() subnetId: any;
  @Output() persisted = new EventEmitter<any>();
  subnet: any;

  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient, private route: ActivatedRoute,
              private router: Router, private alertService: AlertService) {
  }

  ngOnInit(): void {
    if (this.subnetId) {
      this.load(this.subnetId);

    } else {
      this.route.params.subscribe((params: Params) => {
        params['id'] === '0' ? this.createNew() : this.load(params['id']);
      });
    }
  }

  load(id: string): void {
    this.http.get(`${this.env.e.url}/domain/cmdbSubnets/${id}`).subscribe(data => {
      this.subnet = data
    });
  }

  

  createNew(): void {
    // This is a hack to get the form to work with a new object.
    this.subnet = { name: '', vlanId: '', description: '.', network: '', subnet: '24', subnetMask: '', startIP: '1', endIP: '0', gateway: null, companyId: this.auth.getCompanyId() };
  }

  save(): void {
    const isUpdate = !!this.subnet.id;
    const request = isUpdate
      ? this.http.put(`${this.env.e.url}/domain/cmdbSubnets/${this.subnet.id}`, this.subnet)
      : this.http.post(`${this.env.e.url}/domain/cmdbSubnets`, this.subnet);
    request.subscribe(data => {
      this.subnet = data;
      this.alertService.info(`${isUpdate ? 'Updated' : 'Created'} ${this.subnet.name}`);
      this.persisted.emit({data, action: isUpdate ? 'updated' : 'added'});
    });
  }

  delete(): void {
    this.http.delete(`${this.env.e.url}/domain/cmdbSubnets/${this.subnet.id}`).subscribe(() => {
      this.persisted.emit({data: this.subnet, action: 'deleted'});
      this.alertService.info(`Deleted ${this.subnet.name}`);
      if (!this.subnetId) { this.router.navigate(['/cmdbSubnets']); }
    });
  }


}
